export enum ResolverKeys {
  TERMINALS = 'terminals',
  MY_EMPLOYEE = 'my_employee',
  TERMINAL = 'terminal',
  SHOWS = 'shows',
  COUNTRIES = 'countries',
  LANGUAGES = 'languages',
  CURRENCIES = 'currencies',
  SHOW = 'show',
  SECTORS = 'sectors',
  KIOSK_TABS = 'kiosk_tabs',
  KIOSK_PRODUCTS_AND_PACKAGES = 'kiosk_products_and_packages',
  SHOW_PRICE_CATEGORIES = 'show_price_categories',
  SHOW_CASH_PRICES = 'show_cash_prices',
  WEATHER = 'weather',
  RESERVATIONS = 'reservations',
  VOUCHERS = 'vouchers',
  EXTERNAL_VOUCHERS = 'external_vouchers',
  CARDS = 'cards',
  TRANSACTIONS = 'transactions',
  USABLE_CARDS = 'usable_cards',
  ISSUERS = 'issuers',
  PRODUCT_GROUPS = 'product_groups',
  SESSION_STATISTICS = 'session_statistics',
  DATEV_ACCOUNTS = 'datev_accounts',
}
